import axios from 'axios'

export default {
	api: axios.create({params: {format: 'json'}}),

	joinGroup: function (groupId) {
		return this.api.post('/groups/' + groupId + '/join');
	},

	leaveGroup: function (groupId) {
		return this.api.post('/groups/' + groupId + '/leave');
	},

	uploadFile: function(payload) {
		return this.api.post('/attachments/pictures', payload);
	}
};
